import AModal, { type ModalProps } from "antd/lib/modal";

type Props = ModalProps;

export const Modal = ({ ...props }: Props) => {
    return <AModal {...props} />;
};

Modal.useModal = AModal.useModal;

Modal.info = AModal.info;
Modal.success = AModal.success;
Modal.error = AModal.error;
Modal.warning = AModal.warning;
Modal.confirm = AModal.confirm;
